/**
 * This holds the options used to render common select options. Every array of
 * options should have the `_OPTIONS` suffix.
 */
import { DONATION_TYPES } from '@/lib/configs/contributions';

export const DONATION_TYPE_OPTIONS = Object.keys(DONATION_TYPES || {}).map(
  (key) => {
    const type = DONATION_TYPES[key];

    return {
      value: type.value,
      icon: type.icon,
      text: type.displayText,
      featureFlag: type.featureFlag,
    };
  },
);
